import { Component, OnInit } from '@angular/core';
import { Cahier } from '../../../../data/habilitation/models/cahier.model';
import { College } from '../../../../data/commission/models/college.model';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { JuresService } from '../../../../data/commission/services/jures/jures.service';
import { CollegeService } from '../../../../data/commission/services/college/college.service';
import { CahiersService } from '../../../../data/commission/services/cahiers/cahiers.service';
import { SessionContext } from '../../../../core/services/config/app.settings';
import { forkJoin } from 'rxjs';
import * as moment from 'moment/moment';
import { ExportToCsv } from 'export-to-csv';
import { JureExport } from '../../../../data/commission/models/jure-export.model';
import { LoaderService } from '../../../../core/services/loader/loader.service';

@Component({
    selector: 'app-generation-jures',
    templateUrl: './generation-jures.component.html',
    styleUrls: ['./generation-jures.component.scss'],
    standalone: false
})
export class GenerationJuresComponent implements OnInit {
    /**
     * Organisme id connecté
     */
    idOrganisme: number;

    /**
     * Liste des jurés à exporter
     */
    jures: JureExport[] = [];

    /**
     * Liste des colleges
     */
    colleges: College[] = [];

    /**
     * Liste des cahiers des charges
     */
    cahiers: Cahier[] = [];

    /**
     * Form de filtrage
     */
    formFilter: UntypedFormGroup;

    /**
     * Getter cahiers des charges
     */
    get cahier() {
        return this.formFilter.get('cahier');
    }

    /**
     * Getter colleges
     */
    get college() {
        return this.formFilter.get('college');
    }

    constructor(
        private readonly fb: UntypedFormBuilder,
        private readonly loaderService: LoaderService,
        private readonly jureService: JuresService,
        private readonly collegeService: CollegeService,
        private readonly cahiersService: CahiersService
    ) {
        // Récupérer l'ID organisme
        this.idOrganisme = SessionContext.get('idOrganisme');
    }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        // Initialise le formulaire de filtrage
        this.formFilter = this.fb.group({
            college: undefined,
            cahier: undefined
        });

        // Charger les donnees pour les filtres
        forkJoin([this.collegeService.getColleges(), this.cahiersService.getCahiers()])
            .pipe(this.loaderService.operator())
            .subscribe(([colleges, cahiers]) => {
                this.colleges = colleges.sort((a, b) => a.libelle.localeCompare(b.libelle));
                this.cahiers = cahiers.sort((a, b) => a.libelle.localeCompare(b.libelle));
            });
    }

    /**
     * Récupère les jurés à exporter en fonction des filtres
     */
    onExport() {
        this.jureService
            .exportJures(this.idOrganisme, this.college.value, this.cahier.value)
            .pipe(this.loaderService.operator())
            .subscribe(jures => {
                this.jures = jures;
                this.exporter();
            });
    }

    /**
     * Exporter les jurés
     */
    exporter(): void {
        const data = [];
        this.jures.forEach(exp => {
            data.push({
                nom: exp.nom,
                mail: exp.mail,
                telFixe: exp.telFixe ? exp.telFixe : '',
                telPortable: exp.telPortable ? exp.telPortable : '',
                libelleCollege: exp.libelleCollege,
                cahierDesCharges: exp.cahierDesCharges.join(', ')
            });
        });

        const options = {
            filename: 'EXPORT_JURES'.concat('_').concat(moment().format('YYYYMMDD')),
            fieldSeparator: ';',
            quoteStrings: '',
            decimalSeparator: ',',
            showLabels: true,
            showTitle: false,
            title: 'EXPORT_JURES'.concat('_').concat(moment().format('YYYYMMDD')),
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: false,
            headers: ['Juré', 'Email', 'Téléphone', 'Portable', 'Collège', 'Cahier(s) des charges']
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(data);
    }
}
